(() => {
  const fox = window?.FoxTheme;
  const routes = fox?.routes;
  const pageDiscountCode = fox?.pageDiscountCode?.trim();

  if (!pageDiscountCode || !routes?.cart_url || !routes?.cart_update_url) return;
  if (window?.Shopify?.designMode) return;

  const normalizeCode = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '');
  const normalizedPageCode = normalizeCode(pageDiscountCode);

  const getExistingCodes = (cart) => {
    if (!Array.isArray(cart?.discount_codes)) return [];

    return cart.discount_codes
      .map((discount) => {
        if (typeof discount === 'string') return discount.trim();
        if (discount && typeof discount === 'object' && discount.applicable !== false) {
          return (discount.code || discount.title || '').trim();
        }
        return '';
      })
      .filter(Boolean);
  };

  const run = async () => {
    const cartResponse = await fetch(`${routes.cart_url}.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!cartResponse.ok) return;
    const cart = await cartResponse.json();

    const existingCodes = getExistingCodes(cart);
    if (existingCodes.some((code) => normalizeCode(code) === normalizedPageCode)) return;

    const body = new FormData();
    body.append('discount', [...existingCodes, pageDiscountCode].join(','));

    await fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body,
    });
  };

  run().catch((error) => {
    console.error('Page discount auto-apply failed', error);
  });
})();
